import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';
import swal from 'sweetalert2';

export default {
  nfeService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    function (runtimeConstant, $http, $q, $filter, webApiSettings) {
      'use strict';

      var urlSubsidiaries = 'nfe/subsidiaries';
      var urlSearch = 'nfe/searchfornfe';
      var urlRemove = 'nfe/subsidiaries/';
      var nfeFactory = {};
      var lista = [];
      var onCompanie = {};

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 500) {
          return {
            title: $filter('translate')('ERROR'),
            text:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
        }
        return {
          title: $filter('translate')('ERROR'),
          text: err.data,
        };
      }

      function sortColumns() {
        return {
          column: 'id',
          title: 'NFE START DATE',
          type: 'date',
          sortOrder: 'desc',
        };
      }

      function getList() {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri + urlSubsidiaries + '/companies'
          )
          .then(
            function (res) {
              var data = res.data;
              data = resolveReferences(data);
              lista = data;
              deferred.resolve(data);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );
        return deferred.promise;
      }

      function list(list1) {
        if (arguments.length > 0) lista = list1;
        return lista;
      }

      function save(company) {
        var deferred = $q.defer();

        $http
          .post(webApiSettings.apiServiceBaseUri + urlSubsidiaries, company)
          .then(
            function (result) {
              lista.unshift(result.data);
              for (var i = 0; i < lista.length; i++) {
                lista[i].Cnpj = lista[i].Cnpj.replace(
                  /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
                  '$1.$2.$3/$4-$5'
                );
              }
              deferred.resolve(result);
              nfeFactory.list();
              nfeFactory.SearchForNfe(company);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function onCompanie(onCompanie1) {
        if (arguments.length > 0) onCompanie = onCompanie1;
        return onCompanie;
      }

      function getCompanie() {
        var deferred = $q.defer();
        $http.get(webApiSettings.apiServiceBaseUri + 'companies/companie').then(
          function (res) {
            var data = res.data;
            data = resolveReferences(data);
            onCompanie = data;
            deferred.resolve(data);
          },
          function (err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );
        return deferred.promise;
      }

      function searchForNfe(company) {
        var deferred = $q.defer();

        swal.fire('Buscando Notas fiscais', ' Aguarde!');
        $http.post(webApiSettings.apiServiceBaseUri + urlSearch, company).then(
          function () {},
          function errorCallback(err) {
            deferred.reject(handleError(err.data, err.status));
          }
        );

        return deferred.promise;
      }

      function remove(idSubisydiarie) {
        var deferred = $q.defer();
        swal.fire({
          text: 'Removendo filial...',
          showConfirmButton: false,
          allowEscapeKey: false,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        });

        $http
          .delete(webApiSettings.apiServiceBaseUri + urlRemove + idSubisydiarie)
          .then(
            function (result) {
              swal.close();
              deferred.resolve(result);
            },
            function (err) {
              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          nfeFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.getList = logWrapper(
            getList,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.onCompanie = logWrapper(
            onCompanie,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.getCompanie = logWrapper(
            getCompanie,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.SearchForNfe = logWrapper(
            searchForNfe,
            runtimeConstant.isDebugServicesInternals
          );
          nfeFactory.Remove = logWrapper(
            remove,
            runtimeConstant.isDebugServicesInternals
          );

          return nfeFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
